import type { CurvePath, Vector3 } from '@anov/3d-core'

export { RealismTraffic } from './RealismTraffic'

export interface RealismTrafficInterface {

  width: number

  divide: number

  baseTime: number

  lanelines: CurvePath<Vector3>[]
}